export default __webpack_public_path__ + "static/media/product_gray_background.000e8ae0.svg";